/* Spielerfoto wechseln — reine Funktionen; der Upload wird hereingereicht
 * (useFileActions().upload), damit die Regeln ohne Browser prüfbar sind.
 *
 * Ein neu hochgeladenes Foto soll überall sichtbar sein (Liste, Panel, große
 * Info-Karte). Die Karte bevorzugt aber ein hinterlegtes bioPhoto/bioPhotoPath
 * (Altbestand, früher ein eigens hochgeladenes "biometrisches" Foto). Deshalb
 * werden beim Wechsel diese beiden Verweise geleert; avatar (eingebettetes
 * Altbild) ebenfalls, sonst gewinnt es weiter.
 *
 * Es werden KEINE Dateien gelöscht: Der Pfad wird nur im Speicher des
 * Browsers getauscht. In der Datenbank steht der alte, bis der Speichern-Knopf
 * im Panel (PlayerPanel.onSave) gedrückt wird; Verwerfen setzt den alten Stand
 * zurück. Das alte Spielerfoto samt Fassungen räumt domain/fileCleanup.js nach
 * dem erfolgreichen Speichern auf (nur admin). Die Datei zu einem geleerten
 * bioPhotoPath bleibt unter biophoto/<id>/ bewusst liegen und lässt sich dort
 * wiederfinden.
 */

export function photoFolder(playerId) {
  return `avatars/${playerId}`;
}

/** Neues Foto am Spieler eintragen und die Anzeige-Vorrangfelder leeren. */
export function applyNewPhoto(player, stored) {
  player.avatarPath = stored.path;
  player.avatar = null;
  player.bioPhotoPath = null;
  player.bioPhoto = null;
  return player;
}

/** Hochladen; erst nach Erfolg wird der Spieler verändert. Wirft bei Fehler, alles bleibt dann unberührt. */
export async function replacePlayerPhoto(player, file, upload) {
  const stored = await upload(file, photoFolder(player.id));
  applyNewPhoto(player, stored);
  return stored;
}
